import { connect } from 'react-redux';
import { lanMapRoute } from 'util/i18n';

import Footer from './component';

const mapStateToProps = ({ global: { lan, window }, hotel: { hotel, hotelList, hotelData } }) => ({
	lan,
	hotel,
	hotelList,
	hotelData,
	lanRoute: lanMapRoute(lan),
	address: hotelData[hotel].address,
	tel: hotelData[hotel].tel,
	fax: hotelData[hotel].fax,
	registrationNumber: hotelData[hotel].registrationNumber,
	mapLink: hotelData[hotel].mapLink,
	media: window.media,
	contactUs: hotelData[hotel].contactUs,
	bookingCode: hotelData[hotel].bookingCode,
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/index.js